import { useState } from 'react'

export default function TemplateForm({ template, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    Name: template?.Name || '',
    SubjectLine: template?.SubjectLine || '',
    HtmlContent: template?.HtmlContent || template?.DraftHtmlContent || '',
    DraftHtmlContent: template?.DraftHtmlContent || '',
    IsDeleted: false
  })

  const [isDraft, setIsDraft] = useState(!!template?.DraftHtmlContent && !template?.HtmlContent)

  const handleSubmit = (e) => {
    e.preventDefault()
    const payload = {
      Name: formData.Name,
      SubjectLine: formData.SubjectLine,
      IsDeleted: false
    }

    if (isDraft) {
      payload.DraftHtmlContent = formData.HtmlContent
      payload.HtmlContent = null
    } else {
      payload.HtmlContent = formData.HtmlContent
      payload.DraftHtmlContent = null
    }

    onSubmit(payload)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Template Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="Name"
            value={formData.Name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="e.g., Welcome Email"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Subject Line <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="SubjectLine"
            value={formData.SubjectLine}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="e.g., Welcome to our platform!"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          HTML Content <span className="text-red-500">*</span>
        </label>
        <textarea
          name="HtmlContent"
          value={formData.HtmlContent}
          onChange={handleChange}
          required
          rows={12}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white font-mono text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="<html><body><h1>Hello {{name}}!</h1></body></html>"
        />
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Use template variables like {`{{name}}`}, {`{{email}}`}, etc.
        </p>
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="isDraft"
          checked={isDraft}
          onChange={(e) => setIsDraft(e.target.checked)}
          className="w-4 h-4 text-primary-500 bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600 rounded focus:ring-primary-500 focus:ring-2"
        />
        <label htmlFor="isDraft" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
          Save as draft (won't be used in production until published)
        </label>
      </div>

      <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-white bg-primary-500 rounded-lg hover:bg-primary-600 disabled:opacity-50"
        >
          {loading ? 'Saving...' : template ? 'Update Template' : 'Create Template'}
        </button>
      </div>
    </form>
  )
}
